import { GetLocalitiesByName, GetLocalitiesByNameToken } from "$src/application/map/queries/GetLocalitiesByName";
import { Locality } from "$src/domain/map/Locality";
import { useQuery } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

interface FetchLocalityParams {
    queryKey: ['localities', string, string];
}

export async function fetchLocality( { queryKey } : FetchLocalityParams): Promise<Locality[]> {
    const [_, countryCode, nameQuery] = queryKey;
    if( nameQuery.length > 0 && countryCode.length > 0)
    {
        const query = container.resolve<GetLocalitiesByName>(GetLocalitiesByNameToken);
        return query.execute(countryCode, nameQuery);
    }
    else 
    {
        return [];
    }
}

export function useLocality(countryCode: string, nameQuery: string) {
    return useQuery<Locality[], Error, Locality[], ['localities', string, string]>(
        ['localities', countryCode, nameQuery], 
        fetchLocality,
        {
            staleTime: 30000,
            cacheTime: 60000,
        }
    );
}